module.exports = __webpack_public_path__ + "img/sod-w.svg";